import {
  RGBELoader,
} from 'https://threejs.org/examples/jsm/loaders/RGBELoader.js';
import {
  BlendFunction,
  EffectComposer,
  EffectPass,
  RenderPass,
  SelectiveBloomEffect,
} from 'postprocessing';
import * as THREE from 'three';
import { Clock, HalfFloatType } from 'three';

const BACKGROUND_COLOR = '#000';
export default class Renderer {
  constructor(application) {
    this.application = application;
    this.canvas = application.canvas;
    this.sizes = application.sizes;
    this.scene = application.scene;
    this.camera = application.camera;
    this.raycaster = application.raycaster;
    this.gui = application.gui;
    this.fps = 30;
    this.interval = 1000 / this.fps;
    this.then = Date.now();

    this.setRenderer();
    this.setPostprocessing();
  }

  setRenderer() {
    this.instance = new THREE.WebGLRenderer({
      canvas: this.canvas,
      powerPreference: 'high-performance',
      // premultipliedAlpha: false,
      // stencil: false,
      antialias: true,
      alpha: true,
    });
    // this.instance.shadowMap.enabled = true;
    // this.instance.shadowMap.type = THREE.PCFSoftShadowMap
    this.instance.shadowMap.needsUpdate = true;
    this.instance.shadowMap.autoUpdate = true;
    this.instance.shadowMapSoft = true;
    this.instance.toneMapping = THREE.LinearToneMapping;
    this.instance.toneMappingExposure = 1;
    this.instance.autoClear = false;
    this.instance.setClearColor(0x000000, 0);
    this.instance.physicallyCorrectLights = true;

    this.instance.outputColorSpace = THREE.SRGBColorSpace;

    // this.loadEnv('assets/textures/env-map.hdr');

    // this.scene.background = new THREE.Color(BACKGROUND_COLOR);
    // this.scene.background.encoding = THREE.SRGBColorSpace;
    // this.scene.background.colorSpace = THREE.SRGBColorSpace;
    // this.scene.background.minFilter = THREE.LinearFilter;
    // this.scene.background.magFilter = THREE.LinearFilter;
  }

  setPostprocessing() {
    // Render pass
    const renderPass = new RenderPass(this.scene, this.camera.instance);

    this.composer = new EffectComposer(this.instance, {
      multisampling: 4,
      frameBufferType: HalfFloatType,
    });
    this.composer.addPass(renderPass);

    const bloomEffect = new SelectiveBloomEffect(
      this.scene,
      this.camera.instance,
      {
        blendFunction: BlendFunction.ADD,
        mipmapBlur: true,
        filter: true,
        luminanceThreshold: 0.0,
        luminanceSmoothing: 1.0,
        intensity: 1,
        radius: 0.05,
      },
    );
    bloomEffect.inverted = true;
    bloomEffect.ignoreBackground = true;

    this.composer.addPass(
      new EffectPass(
        this.camera.instance,
        bloomEffect,
      ),
    );
  }

  loadEnv(file) {
    const generator = new THREE.PMREMGenerator(this.instance);
    new RGBELoader().load(file, (hdrmap) => {
      const envmap = generator.fromEquirectangular(hdrmap);
      envmap.mapping = THREE.EquirectangularReflectionMapping;
      this.scene.environment = envmap.texture;
      this.scene.environment.colorSpace = THREE.SRGBColorSpace;
    });
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(this.sizes.pixelRatio);
    this.composer.setSize(this.sizes.width, this.sizes.height);
  }

  update() {
    // this.instance.render(this.scene, this.camera.instance);
    const now = Date.now();

    const elapsed = now - this.then;

    if (elapsed > this.interval) {
      this.then = now - (elapsed % this.interval);

      const time = new Clock().getDelta();
      this.composer.render(time);
    }
  }
}
